/**
 * Combine all reducers in this file and export the combined reducers.
 */

import { combineReducers } from "@reduxjs/toolkit";

import {
  api as manageCardsApi,
  slice as manageCardsSlice,
} from "app/pages/Customer/MyAccount/ManageCards/slice";
import { InjectedReducersType } from "utils/types/injector-typings";

/**
 * Reducers registered here are always on the store (avoids injectReducer during
 * child render, which can trigger "Cannot update X while rendering Y" in React).
 */
const staticReducers = {
  [manageCardsSlice.name]: manageCardsSlice.reducer,
  [manageCardsApi.reducerPath]: manageCardsApi.reducer,
} as const;

/**
 * Merges static reducers with dynamically injected reducers
 */
export function createReducer(injectedReducers: InjectedReducersType = {}) {
  const merged = {
    ...staticReducers,
    ...injectedReducers,
  };
  return combineReducers(merged);
}
